import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, QrCode, BarChart3, Users, LogOut, Menu, X, Layers } from 'lucide-react';
import { authService } from '../services/auth';
import { prefetchRoute } from '../services/navigation';
import './Layout.css';

function Layout({ onLogout }) {
  const prefetchTimer = useRef(null);
  const cancelPrefetch = () => clearTimeout(prefetchTimer.current);
  const prepare = path => { cancelPrefetch(); prefetchTimer.current = setTimeout(() => prefetchRoute(path), 100); };
  useEffect(() => () => clearTimeout(prefetchTimer.current), []);
  const [isAdmin, setIsAdmin] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    checkAdminRole();
  }, []);

  const checkAdminRole = async () => {
    try {
      const token = await authService.getIdToken();
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const groups = payload['cognito:groups'] || [];
        setIsAdmin(groups.includes('Admin'));
      }
    } catch (error) {
      console.error('Erro ao verificar role:', error);
    }
  };

  const navItems = [
    { to: '/dashboard', label: 'Início', icon: LayoutDashboard },
    { to: '/qrcodes', label: 'QR Codes', icon: QrCode },
    { to: '/pages', label: 'Páginas', icon: Layers },
    { to: '/reports', label: 'Relatórios', icon: BarChart3 },
    ...(isAdmin ? [{ to: '/users', label: 'Usuários', icon: Users }] : [])
  ];

  return (
    <div className="app-shell">
      <button
        className="sidebar-mobile-toggle"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Abrir menu"
      >
        {mobileOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <span className="sidebar-brand-mark">
            <QrCode size={20} strokeWidth={2.25} />
          </span>
          <span className="sidebar-brand-name font-display">QRBlant</span>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onPointerEnter={() => prepare(to)}
              onPointerLeave={cancelPrefetch}
              onFocus={() => prepare(to)}
              onBlur={cancelPrefetch}
              onClick={() => { cancelPrefetch(); prefetchRoute(to); setMobileOpen(false); }}
            >
              <Icon size={18} strokeWidth={2} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <button className="sidebar-logout" onClick={onLogout}>
          <LogOut size={18} strokeWidth={2} />
          <span>Sair</span>
        </button>
      </aside>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
